import React, { useState } from "react";
import { Table, Button, Card, InputNumber, Typography, Tag, Space, Dropdown, Row } from "antd";
import { DownOutlined } from "@ant-design/icons";
import classes from "../Etablissements/Etablissements.module.css";
const { Title } = Typography;

const apprenants = [
  {
    id: 1,
    identifiant: "14407380",
    nom: "User 1",
    prenom: "user 1",
    formation: "Formation xxx",
    email: "user1@email.com",
    telephone: "28777975",
    modules: [
      { id: 1, nom: "Maths", seuil: 10 },
      { id: 2, nom: "Physique", seuil: 10 },
    ],
  },
  {
    id: 2,
    identifiant: "14407380",
    nom: "User 2",
    prenom: "User 2",
    formation: "Formation YYY",
    email: "user2@email.com",
    telephone: "52145365",
    modules: [
      { id: 1, nom: "Chimie", seuil: 10 },
      { id: 2, nom: "Biologie", seuil: 10 },
    ],
  },
];

const GestionNotes = () => {
  const [selectedApprenant, setSelectedApprenant] = useState(null);
  const [notes, setNotes] = useState({});

  const handleNoteChange = (apprenantId, moduleId, value) => {
    setNotes((prevNotes) => ({
      ...prevNotes,
      [apprenantId]: {
        ...prevNotes[apprenantId],
        [moduleId]: value,
      },
    }));
  };

  const hasNotes = (apprenant) => {
    const apprenantNotes = notes[apprenant.id] || {};
    return apprenant.modules.every((mod) => apprenantNotes[mod.id] !== undefined);
  };

  const columnsApprenants = [
    {
      title: "Nom",
      dataIndex: "nom",
      key: "nom",
    },
 
    {
      title: "Prénom",
      dataIndex: "prenom",
      key: "prenom",
    },

    {
      title: "Cin / Passeport",
      dataIndex: "identifiant",
      key: "identifiant",
    },
    {
      title: "Formation",
      dataIndex: "formation",
      key: "formation",
    },
    {
      title: "Statut",
      key: "statut",
      render: (_, record) => (
        hasNotes(record) ? (
          <Tag color="green">Notes saisies</Tag>
        ) : (
          <Tag color="red">Notes non saisies</Tag>
        )
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (

            <Space>
                  <Dropdown
                    menu={{
                      items: [
                    
                     {
                    label: (
                      <Button  onClick={() => setSelectedApprenant(record)}>
            Saisir les notes
          </Button>
                    ),
                  },
                      
        
                      ],
                    }}
                    trigger={["click"]}
                  >
                    <span style={{ cursor: "pointer" }}>
                      <Space>
                        {("Liste")}
                        <DownOutlined />
                      </Space>
                    </span>
                  </Dropdown>
                </Space>
       
      ),
    },
  ];

  const columnsModules = selectedApprenant
    ? [
        {
          title: "Nom du module",
          dataIndex: "nom",
          key: "nom",
        },
        {
          title: "Seuil",
          dataIndex: "seuil",
          key: "seuil",
        },
        {
          title: "Note",
          key: "note",
          render: (_, record) => (
            <InputNumber
              min={0}
              max={20}
              value={
                notes[selectedApprenant.id]?.[record.id] !== undefined
                  ? notes[selectedApprenant.id][record.id]
                  : undefined
              }
              onChange={(value) =>
                handleNoteChange(selectedApprenant.id, record.id, value)
              }
            />
          ),
        },
        {
          title: "Résultat",
          key: "resultat",
          render: (_, record) => {
            const note = notes[selectedApprenant.id]?.[record.id];
            if (note === undefined) return <Tag>En attente</Tag>;
            return note >= record.seuil ? (
              <Tag color="green">Validé</Tag>
            ) : (
              <Tag color="red">Non validé</Tag>
            );
          },
        },
      ]
    : [];

  return (
    <div style={{ padding: 24 }}>

      {!selectedApprenant ? (

<Row className={classes.listeRow}>


<Card
  className={classes.listeCard}
  bordered={false}
  title={
    <div>
      <h2
       style={{ color: '#2A96FF' }}
      >
        {("Liste des apprenants")}
      </h2>
    </div>
  }
>
<Table
          dataSource={apprenants}
          columns={columnsApprenants}
          rowKey="id"
          pagination={false}
          
        />
</Card>
</Row>
      
      ) : (
        <div>

          <Button onClick={() => setSelectedApprenant(null)} style={{ marginBottom: 16 }}>
            ← Retour à la liste
          </Button>
          <Card title="Informations de l'apprenant" style={{ marginBottom: 24 }}>
            <p><strong>Cin / Passeport:</strong> {selectedApprenant.identifiant}</p>
            <p><strong>Nom:</strong> {selectedApprenant.nom}</p>
            <p><strong>Prénom:</strong> {selectedApprenant.prenom}</p>
            <p><strong>Formation:</strong> {selectedApprenant.formation}</p>
            <p><strong>Email:</strong> {selectedApprenant.email}</p>
            <p><strong>Téléphone:</strong> {selectedApprenant.telephone}</p>
            <p><strong>Statut:</strong> {hasNotes(selectedApprenant) ? <Tag color="green">Notes saisies</Tag> : <Tag color="red">Notes non saisies</Tag>}</p>
          </Card>

<Card
  className={classes.listeCard}
  bordered={false}
  title={
    <div>
      <h3
       style={{ color: '#2A96FF' }}
      >
        {("Liste des modules")}
      </h3>
    </div>
  }
>
  
         

<Table
            dataSource={selectedApprenant.modules}
            columns={columnsModules}
            rowKey="id"
            pagination={false}
            
          />
</Card>

       
        </div>
      )}
    </div>
  );
};

export default GestionNotes;